module.exports = __webpack_public_path__ + "img/spettacololuci.64309688.png";